import React, { useEffect, useState } from "react";
import axios from "axios";

function Banner() {
  const [priceKAS, setPriceKAS] = useState(0);
  const [priceKOON, setPriceKOON] = useState(0);

  useEffect(() => {
    const fetchPriceKAS = async () => {
      try {
        const response = await axios.get(
          "https://api.kaspa.org/info/price?stringOnly=false"
        );
        setPriceKAS(response.data.price);
      } catch (error) {
        console.error("Erreur lors de la récupération du prix du KAS :", error);
      }
    };

    const fetchPriceKOON = async () => {
      try {
        const response = await axios.get(
          "https://api-v2-do.kas.fyi/token/krc20/transactions?ticker=KOON"
        );
        const floorPrice = response.data.results[0].tokenInfo.price.floorPrice;
        setPriceKOON(floorPrice);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération du prix du KOON :",
          error
        );
      }
    };

    fetchPriceKAS();
    fetchPriceKOON();
  }, []);

  const text = `Price KAS: $${priceKAS.toFixed(
    4
  )} | Price KOON: ${priceKOON.toFixed(4)} KAS`;

  return (
    <div id="banner" className="banner section">
      <div className="banner_container">
        <div className="banner_text">
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
          <div className="banner_text_item">{text}</div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
